import React from 'react';
import { Label } from 'react-bootstrap';

class BoldFormatter extends React.Component {
	shouldComponentUpdate(nextProps) {
		return (nextProps.value !== this.props.value);
	}

	render() {
		var color = "#000000";
		var bg = this.props.backgroundColor;
		var label = this.props.value;

		let style = {
			backgroundColor: bg,
			color: color,
			display: "block",
			position: "relative",
			width: "100%",
			height: "34px",
			paddingTop: "10px",
			margin: "0",
			padding: "0",
			borderColor: "#d2d6de",
    		borderRadius: "0",
			borderStyle: this.props.borderStyle,
    		borderWidth: "1px"
		};

		return (
			<React.Fragment>
				<Label style={style}>
					<span style={{ display: "block", paddingTop: "12px" }}>
						{label}
					</span>
				</Label>
			</React.Fragment>
		)
	}
}

export default BoldFormatter;

BoldFormatter.defaultProps = {
	backgroundColor: "transparent",
	borderStyle: ""
};


// WEBPACK FOOTER //
// ./src/areas/admin/shared/BoldFormatter.js